import { Injectable } from '@angular/core';

export interface User {
  username: string;
  name: string;
  lastName: string;
  email: string;
  id: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private user: User | null = null;

  loginWithToken(token: string): void {
    localStorage.setItem('token', token);

    const payload = this.decodeJwtPayload(token);
    const userData =
      typeof payload.User === 'string'
        ? JSON.parse(payload.User)
        : payload.User;

    const usuario = userData.UserName || userData.Usuario || userData.Id || userData.Email;
    const nombreCompleto = `${userData.FirstName || ''} ${userData.LastName || ''}`.trim();
    const email = userData.Email || userData.email;

    if (usuario) localStorage.setItem('usuario', usuario);
    if (nombreCompleto) localStorage.setItem('nombreCompleto', nombreCompleto);
    if (email) localStorage.setItem('email', email);

    this.user = {
      username: usuario ?? '',
      name: userData.FirstName ?? '',
      lastName: userData.LastName ?? '',
      email: email ?? '',
      id: userData.Id ?? '',
    };
  }

  logout(): void {
    this.user = null;
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('nombreCompleto');
    localStorage.removeItem('email');
  }

  getUser(): User | null {
    return this.user;
  }

  getUsername(): string | null {
    return this.user ? this.user.username : null;
  }

  private decodeJwtPayload(token: string): any {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '=');
    return JSON.parse(atob(padded));
  }
}
